import ReactDOM from "react-dom/client";
import App from "./App";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "wc-toast";
// import Svg from "./assets/svg/Svg";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <ToastContainer
      hideProgressBar={true}
      position="top-right"
      autoClose={2000}
      draggable
      style={{ zIndex: "99999999" }}
    />
    {/* <Svg/> */}
    <App />
  </>
);
